import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { getTransferUnits, TransferUnit } from "@/services/sintegradaserver/transferUnits/getTransferUnits";

import { Additional, SelectComponent, SelectComponentProps } from "@/components/SelectComponent";

type Props = SelectComponentProps;

export function TransferUnitSelect({
    ...rest
}: Props) {
    const { ibgeCode } = useCurrentAccount();

    const loadAsynsTransferUnitOptionProps = {
        additional: {
            page: 1,
        },
        isAsyncPaginate: true,
        async loadOptions(search: string, _: TransferUnit, { page }: Additional) {
            const { data, meta } =  await getTransferUnits({ ibgeCode, page, search });

            const hasMore = meta.current_page < meta.last_page;

            const options = data.map((transferUnit) => ({
                label: transferUnit.name,
                value: transferUnit.id,
            }));

            const additional = {
                page: page + 1,
            };

            return {
                hasMore,
                options,
                additional,
            };
        },
    };
    
	return (
		<SelectComponent
            placeholder="Selecione..."
            {...loadAsynsTransferUnitOptionProps}
            {...rest}
		/>
	);
}